import { createRouter, createWebHistory } from "vue-router";
import Auth from "../composables/shop/auth";
import Home from "../components/shop/layout/Home.vue";
import Login from "../components/shop/auth/Login.vue";
import Register from "../components/shop/auth/Register.vue";
import Profile from "../components/shop/auth/Profile.vue";
import Product from "../components/shop/product/Index.vue";
import Cart from "../components/shop/product/Cart.vue";
import LeftSidebar from "../components/shop/layout/LeftSidebar.vue";
import Reserve from "../components/shop/product/Reserve.vue";
import Order from "../components/shop/product/Order.vue";
import OrderReturnForm from "../components/shop/product/OrderReturnForm.vue";
import OrderReturn from "../components/shop/product/OrderReturn.vue";
import Orders from "../components/shop/product/Orders.vue";
import Notification from "../components/shop/layout/Notification.vue";
import Video from "../components/shop/layout/Video.vue";
import SendOrder from "../components/shop/product/SendOrder.vue";
import Award from "../components/shop/layout/Award.vue";
import Application from "../components/shop/layout/Application.vue";
import BugReport from "../components/shop/layout/BugReport.vue";
import RecruitmentForm from "../components/shop/layout/RecruitmentForm.vue";
import cooperationSale from "../components/shop/layout/CooperationSale.vue";
import PageNotFound from "../components/layout/PageNotFound.vue";
import Category from "../components/shop/product/Category.vue";
// import Payment from "../components/layout/PaymentStatus.vue";

const title = document.title.split(" - ")[0];
const baseRoute = "/app/";
const routes = [
  {
    path: baseRoute.replace(/.$/, ""),
    name: "home",
    component: Home,
  },
  {
    path: baseRoute + "login",
    name: "login",
    component: Login,
    meta: {
      title: window.i18n["Login"],
    },
  },
  {
    path: baseRoute + "register",
    name: "register",
    component: Register,
    meta: {
      title: window.i18n["Register"],
    },
  },
  {
    path: baseRoute + "product",
    name: "product",
    component: Product,
    meta: {
      title: window.i18n["products List"],
      titleClass: "bg-gray-custom-4 !text-gray-custom-5",
      tableClass: "odd:bg-gray-custom-6",
    },
  },
  {
    path: baseRoute + "product-special",
    name: "product.special",
    component: Product,
    meta: {
      type: "discount",
      title: window.nikran.special_title,
      titleClass: "bg-error !text-gray-custom-5",
      tableClass: "odd:bg-red-custom-5",
    },
  },
  {
    path: baseRoute + "product-new",
    name: "product.new",
    component: Product,
    meta: {
      type: "new",
      title: window.i18n["new products"],
      titleClass: "bg-blue-custom-4 !text-blue-custom-3",
      tableClass: "odd:bg-blue-custom-3",
    },
  },
  {
    path: baseRoute + "product-change",
    name: "product.change",
    component: Product,
    meta: {
      type: "change",
      feature: "wholesale_price_change",
      title: window.i18n["Product price changes"],
      titleClass: "bg-purple-custom-4 !text-purple-custom-5",
      tableClass: "odd:bg-purple-custom-6",
    },
  },
  {
    path: baseRoute + "product-update",
    name: "product.update",
    component: Product,
    meta: {
      type: "update",
      title: window.i18n["Entrance to the warehouse of charged products"],
      titleClass: "bg-yellow-custom-1 !text-gray-custom-8",
      tableClass: "odd:bg-yellow-custom-2",
    },
  },
  {
    path: baseRoute + "cart",
    name: "cart",
    component: Cart,
    meta: {
      type: "cart",
      title: window.i18n["Cart"],
      tableClass: "odd:bg-orange-custom-4",
    },
  },
  // {
  //   path: baseRoute + "payment/:track",
  //   name: "payment.show",
  //   component: Payment,
  //   meta: {
  //     title: i18n["Payment Status"],
  //   },
  // },
  {
    path: baseRoute + "cart-info",
    name: "cart.info",
    component: LeftSidebar,
    meta: {
      title: window.i18n["Cart"],
    },
  },
  {
    path: baseRoute + "reserve",
    name: "reserve",
    component: Reserve,
    meta: {
      type: "reserve",
      title: window.i18n["Reserve goods list"],
    },
  },
  {
    path: baseRoute + "orders",
    name: "orders",
    component: Orders,
    meta: {
      title: window.i18n["Factors"],
    },
  },
  {
    path: baseRoute + "orders/:id",
    name: "order",
    component: Order,
    meta: {
      title: window.i18n["Order details"],
    },
  },
  {
    path: baseRoute + "orders/return/:id/",
    name: "order.return",
    component: OrderReturn,
    meta: {
      title: window.i18n["Return of goods"],
    },
  },
  {
    path: baseRoute + "orders/:id/return",
    name: "order.return.register",
    component: OrderReturnForm,
    meta: {
      title: window.i18n["Return registration"],
    },
  },
  {
    path: baseRoute + "profile",
    name: "profile",
    component: Profile,
    meta: {
      title: window.i18n["Profile"],
    },
  },
  {
    path: baseRoute + "notification",
    name: "notification",
    component: Notification,
    meta: {
      title: window.i18n["Messages"],
    },
  },
  {
    path: baseRoute + "video/education",
    name: "video.education",
    component: Video,
    meta: {
      title: window.i18n["Educational videos"],
      feature: "video_training",
    },
  },
  {
    path: baseRoute + "video/application",
    name: "video.application",
    component: Video,
    meta: {
      title: window.i18n["Application training"],
      feature: "app_training",
    },
  },
  {
    path: baseRoute + "send-order",
    name: "send.order",
    component: SendOrder,
    meta: {
      title: window.i18n["Delivery schedule"],
      feature: "schedule_sending",
    },
  },
  {
    path: baseRoute + "award",
    name: "award",
    component: Award,
    meta: {
      title: window.i18n["Lottery"],
      feature: "lottery",
    },
  },
  {
    path: baseRoute + "category/:type?",
    name: "category",
    component: Category,
    meta: {
      title: window.i18n["Categories"],
    },
  },
  {
    path: baseRoute + "application",
    name: "application",
    component: Application,
    meta: {
      title: window.i18n["Install the application"],
    },
  },
  {
    path: baseRoute + "cooperation-sale",
    name: "cooperation.sale",
    component: cooperationSale,
    meta: {
      title: window.i18n["Cooperation in sales"],
    },
  },
  {
    path: baseRoute + "bug-report",
    name: "bug.report",
    component: BugReport,
    meta: {
      title: window.i18n["Bug Report"],
    },
  },
  {
    path: baseRoute + "recruitment-form",
    name: "recruitment.form",
    component: RecruitmentForm,
    meta: {
      title: window.i18n["Recruitment form"],
      feature: "job_form",
    },
  },
  {
    path: "/:pathMatch(.*)",
    name: "not.found",
    component: PageNotFound,
    meta: {
      title: window.i18n["Page not found"],
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  linkActiveClass: "active " + window.activeColor,
  linkExactActiveClass: "",
});

router.beforeEach((to, from, next) => {
  const name = to.name?.toString();
  const disabled = window.nikran?.features_disabled || [];
  if (to?.meta?.title) document.title = to?.meta?.title + " | " + title;
  let allowed = ["home", "login", "register", "application"].includes(name);
  if (allowed)
    document
      .querySelector(".Vue-Toastification__container.bottom-right")
      .classList.remove("!mb-16");
  else
    document
      .querySelector(".Vue-Toastification__container.bottom-right")
      .classList.add("!mb-16");
  if (Auth.check()) {
    if (["home", "login", "register"].includes(name))
      router.replace({ name: "product" });
    else if (
      (to.meta.feature && disabled.includes(to.meta.feature)) ||
      (!window.nikran.special_title && name === "product.special")
    )
      router.replace("not-found");
    else {
      if (name !== "profile" && from?.name?.toString() !== name) Auth.getUser();
      next();
    }
  } else if (!allowed) router.push({ name: "login" });
  else next();
});
// router.afterEach((to, from) => {

// });
export default router;
